import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableWrapper,
} from '../../../CommonComponents/OPL/Table/Table';
import { TextLoading } from '../../../CommonComponents/OPL/Text/Text.loading';

export const AssetAllocationChartLoading = () => {
  return (
    <>
      <Box px="12" py="24">
        <Shimmer height={20} width={200} mb="12" />
        <Shimmer height={32} width="100%" />
      </Box>

      <TableWrapper variant="embedded">
        <TableHeader>
          <TableRow>
            <TableCell width="100%">&nbsp;</TableCell>
          </TableRow>
        </TableHeader>

        <TableBody>
          {times(4).map(key => (
            <TableRow key={key} css="padding: 4px 16px">
              <TableCell width="34%">
                <TextLoading height="h4" width={100} />
              </TableCell>
              <TableCell width="33%" justifyContent="flex-end">
                <TextLoading height="h4" width={200} />
              </TableCell>
              <TableCell width="33%" justifyContent="flex-end">
                <TextLoading height="h4" width={40} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableWrapper>
    </>
  );
};
